module.exports = __webpack_public_path__ + "img/company_banner.334e141e.png";